
export const ZoomIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    viewBox="0 0 600 600"
    width="18"
    height="18"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className={className}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M270 60C153 60 60 153 60 270C60 387 153 480 270 480C327 480 378 459 417 420L423 414C459 375 483 324 483 267C480 153 387 60 270 60ZM480 438C516 393 540 333 540 270C540 120 420 0 270 0C120 0 0 120 0 270C0 420 120 540 270 540C333 540 393 519 438 480L549 591C561 603 579 603 591 591C603 579 603 561 591 549L480 438ZM270 150C288 150 300 162 300 180V240H360C378 240 390 252 390 270C390 288 378 300 360 300H300V360C300 378 288 390 270 390C252 390 240 378 240 360V300H180C162 300 150 288 150 270C150 252 162 240 180 240H240V180C240 162 252 150 270 150Z"
    />
  </svg>
)
